import React, { useId } from 'react';
import { COLORS } from '../../../styles/tokens';

// Gull bryter (designets «Tog»).
export function Switch({ checked, onChange, labelledBy, describedBy, disabled }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-labelledby={labelledBy}
      aria-describedby={describedBy}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      style={{
        width: 50, height: 30, borderRadius: 99, border: 'none', padding: 0, position: 'relative', flexShrink: 0,
        cursor: disabled ? 'default' : 'pointer', background: checked ? COLORS.accent : COLORS.border,
        transition: 'background 0.15s',
      }}
    >
      <span style={{
        position: 'absolute', top: 3, left: checked ? 23 : 3, width: 24, height: 24, borderRadius: 99,
        background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,.25)', transition: 'left 0.15s',
      }} />
    </button>
  );
}

// Rad med tittel, valgfri forklaring og bryter (designets «TRow»).
export default function SwitchRow({ title, sub, checked, onChange }) {
  const labelId = useId();
  const subId = useId();
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '9px 0' }}>
      <div style={{ flex: 1 }}>
        <div id={labelId} style={{ fontWeight: 600, fontSize: 14.5, color: COLORS.textDark }}>{title}</div>
        {sub && <div id={subId} style={{ fontSize: 12, color: COLORS.textMid, lineHeight: 1.3, marginTop: 2 }}>{sub}</div>}
      </div>
      <Switch checked={checked} onChange={onChange} labelledBy={labelId} describedBy={sub ? subId : undefined} />
    </div>
  );
}
